import React from "react";
import { Modal, Card, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import useFetch from "./fetch";

export function SignUpCodeModal({ show, handleClose, signUpCode }) {
  const fetch = useFetch();
  const { resident, organization, current_user } = useSelector(
    (state) => state
  );

  function handleYes() {
    fetch(`/organizations/${organization.name}/residents/${resident.id}.json`, {
      method: "PATCH",
      data: {
        resident: {
          add_to_admitted_group_chat: true,
          added_to_admitted_group_chats_by_id: current_user.id,
        },
      },
    }).then(handleClose);
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Card.Header>Generate Sign Up Code</Card.Header>
      <Card.Body className="p-3">
        <div className="text-center py-3">
          {resident.first_name}'s sign up code is: <b>{signUpCode}</b>
        </div>
        <div>
          Would you like {resident.first_name} to be automatically added to the
          admitted group message for facilities {resident.first_name} is
          currently admitted to? &nbsp;
          <i>
            (If yes, {resident.first_name} will be added when they sign up via
            the Client App)
          </i>
        </div>
        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
          <Button variant="outline-primary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" className="ml-3" onClick={handleYes}>
            Yes
          </Button>
        </div>
      </Card.Body>
    </Modal>
  );
}
